import { z } from 'zod';
import { Complectation, ComplectationSchema } from '@/types/complectation/complectation.type.ts';
import { PaginationMeta, PaginationMetaSchema } from '@/types/pagination-meta.ts';

export type ComplectationsPaginator = {
    data: Complectation[],
    meta: PaginationMeta,
};

export type ComplectationsRequestFilter = {
    brand_id?: number,
    model_id?: number[],
    code?: string,
    page?: number,
    sort?: Record<string, string>[],
};

export const ComplectationsSchema = z.array(ComplectationSchema);

export const ComplectationsPaginatorSchema = z.object({
    data: ComplectationsSchema,
    meta: PaginationMetaSchema,
});
